import abstractApi from './abstract'
import keywordApi from './keyword'
import reportApi from './report'


const KnowledgeServer = {
  abstractApi : abstractApi,
  keywordApi : keywordApi,
  reportApi : reportApi
};

export default KnowledgeServer;
